import { render, staticRenderFns } from "./Conta.vue?vue&type=template&id=d2beaa5c&scoped=true"
import script from "./Conta.vue?vue&type=script&lang=js"
export * from "./Conta.vue?vue&type=script&lang=js"
import style1 from "./Conta.vue?vue&type=style&index=1&id=d2beaa5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2beaa5c",
  null
  
)

export default component.exports